import { getKeyByValue } from '@common/object.services';
import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { ECompanyTypeIdConst, ECompanyTypeNameConst } from './companyType.constants';
import { ICompanyType } from './companyType.models';

export const apiRoutes = {
  companyTypes: '/Companies/CompanyTypes',
};

export const getCompanyTypesAsync = createGetOptionsNoPropsFn<ICompanyType>(apiRoutes.companyTypes);

export const getCompanyTypeNameByCompanyTypeId = (id: number | undefined) => {
  if (!id) return null;
  const key = getKeyByValue(ECompanyTypeIdConst, id);
  const value = ECompanyTypeNameConst[key as keyof typeof ECompanyTypeNameConst];
  return value;
};
